var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCameraIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 101.945,
    height: 89,
    viewBox: "0 0 101.945 89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_576",
    "data-name": "Rectangle 576",
    width: 101.945,
    height: 89,
    fill: "#003383"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10511",
    "data-name": "Group 10511",
    transform: "translate(0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10349",
    "data-name": "Group 10349",
    transform: "translate(-0.001 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27729",
    "data-name": "Path 27729",
    d: "M75.842,10.669h7.672A18.487,18.487,0,0,1,101.945,29.1V70.575A18.476,18.476,0,0,1,83.514,89H18.431A18.476,18.476,0,0,1,0,70.575V29.1A18.487,18.487,0,0,1,18.431,10.669H26.1a14.45,14.45,0,0,1,3.884-6.078C32.941,1.747,37,0,40.154,0H61.793C64.936,0,69,1.747,71.965,4.591a14.343,14.343,0,0,1,3.878,6.078M50.97,27.373a22.47,22.47,0,1,1-15.881,6.581A22.413,22.413,0,0,1,50.97,27.373m11,11.466a15.575,15.575,0,1,0,4.547,10.994A15.518,15.518,0,0,0,61.971,38.84M83.514,17.584h-10.6a3.456,3.456,0,0,1-3.456-3.458,6.56,6.56,0,0,0-2.278-4.571,8.784,8.784,0,0,0-5.388-2.642H40.154a8.8,8.8,0,0,0-5.4,2.642,6.6,6.6,0,0,0-2.276,4.571,3.452,3.452,0,0,1-3.451,3.458h-10.6A11.564,11.564,0,0,0,6.913,29.1V70.575A11.564,11.564,0,0,0,18.431,82.092H83.514A11.561,11.561,0,0,0,95.033,70.575V29.1A11.561,11.561,0,0,0,83.514,17.584",
    transform: "translate(0 0)",
    fill: "#003383"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraIcon);
export default __webpack_public_path__ + "static/media/camera_icon.3b35cf7de026b12069265a4260c9b7b3.svg";
export { ForwardRef as ReactComponent };